import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import axios from 'axios'

import Header from '../header/Header'
import Spinner from '../common/Spinner'
import FinalProductContainer from '../final-product/FinalProductConainer'
import { Breadcrumb, HeaderBreadcrumb, BreadcrumbPortal } from '../common/Breadcrumb'
import { articlesApi } from '../../api/articlesApi'

/**
 * Ficha de un producto final dentro del Catálogo v2.
 *
 * Reutiliza FinalProductContainer, el mismo componente que usa el catálogo
 * antiguo: la ficha —documentos, imágenes, vídeo— queda EXACTAMENTE igual.
 * Aquí sólo se resuelve la ruta y se pide el artículo.
 *
 * Usa articlesApi.getInfoArticle, del motor antiguo, sin modificarlo. Llamarlo
 * no rompe la Regla 1; modificarlo sí lo haría. La ficha no forma parte del
 * trabajo del buscador y no hay motivo para duplicarla.
 *
 * Existe esta versión, y no se delega en el catálogo antiguo, porque a partir
 * del nivel de categoría el subárbol es de v2: si esta ruta cayera en el
 * catálogo viejo, se perdería la miga de pan acumulada.
 */
const FinalProductBrowseV2 = ({ match }) => {
  const id = match.params.idProducto
  const history = useHistory()

  const [item, setItem] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fuente = axios.CancelToken.source()

    articlesApi
      .getInfoArticle(id)
      .then((res) => setItem(res.data))
      .catch((err) => {
        if (axios.isCancel(err)) return
        const codigo = err && err.response ? err.response.status : '—'
        setError(`No se ha podido cargar el producto (HTTP ${codigo}).`)
      })

    return () => fuente.cancel()
  }, [id])

  return (
    <>
      {/* Migaja sin texto, igual que el catálogo antiguo: el nombre del
          producto ya lo muestra la propia ficha, y repetirlo alarga el rastro
          sin aportar nada. */}
      <Breadcrumb to={match.url}> </Breadcrumb>

      <div className='products'>
        <Header text={'Catálogo'} route={() => history.goBack()} backBtn={true} />

        <div className='filter__wrap-right mb-80'>
          <HeaderBreadcrumb>
            <BreadcrumbPortal />
          </HeaderBreadcrumb>
        </div>

        {error ? (
          <div
            style={{
              margin: '10px 0',
              padding: '8px 12px',
              fontSize: 13.5,
              fontWeight: 600,
              color: '#a32218',
              background: '#f6e3e1',
              borderLeft: '3px solid #a32218',
            }}
          >
            {error}
          </div>
        ) : item ? (
          <FinalProductContainer item={item} />
        ) : (
          <Spinner bloque />
        )}
      </div>
    </>
  )
}

export default FinalProductBrowseV2
